import { nonEmptyArray } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { PDPInternalState, PDPSwarovskiProductFrontend, PDPSwarovskiProductVariantFrontend } from "./types";
import { selectVariantForAttributesState } from "./select-variant-for-attributes-state";

export function getCurrentAttributesSelection(
  selectedProduct: PDPSwarovskiProductFrontend,
  selectedVariant: PDPSwarovskiProductVariantFrontend | undefined,
  multiselectsForProduct: PDPInternalState["multiselectsForProduct"],
) {
  if (selectedVariant) {
    return {
      selectedVariant: selectedVariant,
      attributesSelection: selectedVariant.attributes.unique || [],
      tag: "user-picked" as const,
    };
  } else {
    const desiredAttributesSelection = (multiselectsForProduct || []).flatMap(m =>
      pipe(m.attributes, nonEmptyArray.head),
    );

    return {
      ...selectVariantForAttributesState(selectedProduct, desiredAttributesSelection, undefined),
      tag: "auto-selected" as const,
    };
  }
}
